
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/crops/[cropSlug]",
      function () {
        return require("private-next-pages/products/crops/[cropSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/crops/[cropSlug]"])
      });
    }
  